import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=2300c8c4&"
import script from "./AddClient.ts?vue&type=script&lang=ts&"
export * from "./AddClient.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports